import { cn } from "../../../helpers";
import styles from "./Skeleton.module.scss";

interface SkeletonProps {
    className?: string;
    count?: number;
}

export default function Skeleton({ className, count }: SkeletonProps) {
    return (
        <div className={cn(styles.skeletonWrapper, className)}>
            <div className={styles.rows}>
                {[...new Array(count || 8)].map((_, index) => (
                    <div
                        key={index}
                        className={cn(styles.row, {
                            [styles.firstRow]: index === 0,
                        })}
                    />
                ))}
            </div>
        </div>
    );
}
